/**
 * External destinations, declared once.
 *
 * Discord invite codes get revoked and rotated; before this existed the code
 * was pasted in six places across four files, so a rotation meant hunting
 * every copy. See issue #17.
 */
export const EXTERNAL = {
  discord: 'https://discord.com/invite/5pETpm6Sr7',
  youtube: 'https://www.youtube.com/@ISN_Network',
  instagram:
    'https://www.instagram.com/isn.network/?igsh=MXBmZXpseGlka3VjaQ%3D%3D#',
  // Placeholder: points at the TikTok homepage, not an ISN profile. See #11.
  tiktok: 'https://www.tiktok.com/',
  store: 'https://store.isnserver.net/',
};

/** Server address as displayed. */
export const SERVER_IP = 'ISNSERVER.NET';

/** What actually goes on the clipboard when a player copies the address. */
export const SERVER_ADDRESS = 'isnserver.net';
